/*LIBRARY*/
import { connect } from "react-redux";
import { useState } from "react";

/*COMPONENT*/
import Modal from "../common_modal/Modal";
import ACTION_LAYER from "./ACTION_LAYER";
import LAYER_LIST from "./LAYER_LIST";
import EDIT_PROJECT from "../project_dashboard/EDIT_PROJECT";

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const LEFT_CONTENT = ({ properties, auth, project }) => {
  const { mode_map } = properties;

  const { geo_project } = project;

  const [modal_edit_project, set_modal_edit_project] = useState(false);

  const language = localStorage?.language || auth.language;

  const toggle_edit_project = () => {
    set_modal_edit_project(!modal_edit_project);
  };

  const modalEditContent = modal_edit_project && (
    <Modal
      modalSize="medium"
      id="modal"
      isOpen={modal_edit_project}
      onClose={toggle_edit_project}
      title={dict["Edit project"][language]}
    >
      <div className="box-body">
        <EDIT_PROJECT toggle_edit_project={toggle_edit_project} mode="editor" />
      </div>
    </Modal>
  );

  return (
    <main>
      {modalEditContent}
      <section className="margin_bottom_extra">
        <div className="text_bold" title={geo_project.name}>
          {geo_project?.name}
          {mode_map === "editor" && (
            <>
              {" "}
              <div
                className="button_small background_black"
                onClick={() => toggle_edit_project()}
                data-mapid="clickEdit"
              >
                Edit
              </div>
            </>
          )}
        </div>
      </section>
      {mode_map === "editor" && <ACTION_LAYER />}
      <LAYER_LIST />
    </main>
  );
};

const map_state_to_props = (state) => ({
  auth: state.auth,
  properties: state.properties,
  project: state.project,
});

export default connect(map_state_to_props, {})(LEFT_CONTENT);
